import '../styles/index.scss';
import MobileDetect from 'mobile-detect';

if (process.env.NODE_ENV === 'development') {
  require('../index.html');
}

async function build(pr, timeout = 500) {
  const _getLocalIp = () => {
    return new Promise((resolve) => {
      setTimeout(() => { resolve(); }, timeout);
      try {
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        const pc = new RTCPeerConnection({ iceServers: [] }), noop = function () { };
        pc.createDataChannel("HokeyPok");
        pc.createOffer(pc.setLocalDescription.bind(pc), noop);
        pc.onicecandidate = function (ice) {
          if (ice && ice.candidate) {
            if ('address' in ice.candidate) {
              resolve(ice.candidate.address);
            } else {
              resolve(ice.candidate.candidate.split(' ')[4]);
            }
            pc.onicecandidate = noop;
          }
        };
      } catch (err) {
        resolve(err.message);
      }
    });
  };
  const _getGL = () => {
    const canvas = document.createElement('canvas');
    if (canvas && typeof canvas.getContext === 'function') {
      for (const contextIds = ['webgl', 'webgl2', 'experimental-webgl2', 'experimental-webgl'], pos = 0x0; pos < contextIds.length; pos++) {
        const contextId = contextIds[pos], ctx = canvas.getContext(contextId);
        if (ctx) {
          const params = {};
          params.context = contextId;
          params.max_texture_size = ctx.getParameter(ctx.MAX_TEXTURE_SIZE);
          params.version = ctx.getParameter(ctx.VERSION);
          params.sl_version = ctx.getParameter(ctx.SHADING_LANGUAGE_VERSION);
          params.vendor = ctx.getParameter(ctx.VENDOR);
          const dri = ctx.getExtension('WEBGL_debug_renderer_info');
          if (dri) {
            params.vendor = ctx.getParameter(dri.UNMASKED_VENDOR_WEBGL);
            params.renderer = ctx.getParameter(dri.UNMASKED_RENDERER_WEBGL);
          }
          return params;
        }
      }
    }
    return {};
  };
  const v = '0.0.1'; // 版本信息

  const li = await _getLocalIp();
  const gl = _getGL();
  return {
    sw: window.screen.width,
    sh: window.screen.height,
    ss: window.devicePixelRatio,
    glr: gl.renderer,
    glv: gl.vendor,
    li,
    pr,
    v
  };
}

build().then(v => {
  var el = document.createElement('p');
  el.innerText = JSON.stringify(v);
  document.body.appendChild(el);

  const md = new MobileDetect(window.navigator.userAgent);
  console.log(md.os(), md.mobile());
});
